{
  "name": "gloomhavensecretariat",
  "version": "0.169.1",
  "license": "AGPL3",
  "description": "Gloomhaven Secretariat is a Gloomhaven/Frosthaven Companion app.",
  "homepage": "https://gloomhaven-secretariat.de",
  "author": {
    "name": "Lurkars",
    "email": "contact@gloomhaven-secretariat.de",
    "url": "https://www.champonthis.de"
  },
  "repository": "github:Lurkars/gloomhavensecretariat",
  "bugs": "https://github.com/Lurkars/gloomhavensecretariat/issues",
  "funding": {
    "type": "ko-fi",
    "url": "https://ko-fi.com/lurkars"
  },
  "main": "main.js",
  "engines": {
    "node": ">=24"
  },
  "nodemonConfig": {
    "execMap": {
      "js": "node ./scripts/build-data.js"
    },
    "watch": [
      "data/"
    ],
    "ext": "json",
    "runOnChangeOnly": true
  },
  "scripts": {
    "prepare": "husky",
    "prestart": "node ./scripts/build-data.js",
    "start": "ng serve",
    "prebuild": "node ./scripts/build-data.js && node ./scripts/pre-build.js",
    "build": "ng build",
    "postbuild": "node ./scripts/post-build.js",
    "pretest": "node ./scripts/build-data.js",
    "test": "ng test",
    "lint": "eslint \"src/**/*.{ts,html}\"",
    "lint:fix": "eslint \"src/**/*.{ts,html}\" --fix",
    "format": "prettier --write \"src/**/*.{ts,html,scss}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,scss}\"",
    "watch": "nodemon",
    "electron": "npm run build -- --configuration production,electron --base-href ./ && electron . --no-sandbox",
    "electron:build": "npm run build -- --configuration production,electron --base-href ./ && electron-builder",
    "electron:build:linux:appimage": "npm run build -- --configuration production,electron --base-href ./ && electron-builder --linux AppImage",
    "patch-android": "node ./scripts/patch-android.js"
  },
  "build": {
    "appId": "gloomhavensecretariat",
    "publish": [
      {
        "provider": "github",
        "owner": "Lurkars",
        "repo": "gloomhavensecretariat"
      }
    ],
    "linux": {
      "target": [
        "AppImage",
        "rpm",
        "deb"
      ]
    },
    "mac": {
      "type": "distribution",
      "target": [
        {
          "target": "dmg",
          "arch": [
            "universal"
          ]
        },
        {
          "target": "pkg",
          "arch": [
            "universal"
          ]
        }
      ]
    },
    "win": {
      "target": "nsis",
      "icon": "build/icon.ico"
    },
    "files": [
      "main.js",
      "dist/gloomhavensecretariat"
    ]
  },
  "private": true,
  "overrides": {
    "@babel/core": "8.0.1",
    "esbuild": "0.28.1",
    "xcode": {
      "uuid": "14.0.1"
    }
  },
  "dependencies": {
    "@angular/cdk": "~22.1.3",
    "@angular/common": "~22.1.3",
    "@angular/compiler": "~22.1.3",
    "@angular/core": "~22.1.3",
    "@angular/forms": "~22.1.3",
    "@angular/platform-browser": "~22.1.3",
    "@angular/router": "~22.1.3",
    "@angular/service-worker": "~22.1.3",
    "@capacitor/app": "^8.1.1",
    "@capacitor/core": "^8.5.0",
    "autocompleter": "^10.0.0",
    "electron-updater": "^6.8.9",
    "leaflet": "^1.9.4",
    "mermaid": "^11.17.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^14.0.2"
  },
  "devDependencies": {
    "@angular-eslint/schematics": "^22.1.0",
    "@angular/build": "^22.1.5",
    "@angular/cli": "~22.1.5",
    "@angular/compiler-cli": "~22.1.3",
    "@capacitor/android": "^8.5.0",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^8.5.0",
    "@capacitor/ios": "^8.5.0",
    "@types/dom-screen-wake-lock": "1.0.3",
    "@types/leaflet": "^1.9.22",
    "angular-eslint": "^22.1.0",
    "browserslist": "^4.28.8",
    "electron": "^43.4.1",
    "electron-builder": "^26.15.7",
    "eslint": "^10.8.1",
    "eslint-config-prettier": "^10.1.8",
    "http-server": "^14.1.1",
    "husky": "^9.1.7",
    "jsdom": "^30.0.1",
    "lint-staged": "^17.3.0",
    "nodemon": "^3.1.14",
    "prettier": "^3.9.6",
    "prettier-plugin-organize-imports": "^4.3.0",
    "tsx": "^4.23.12",
    "typescript": "~6.0.3",
    "vitest": "^4.1.11"
  },
  "lint-staged": {
    "src/**/*.{ts,html}": [
      "eslint --fix",
      "prettier --write"
    ],
    "src/**/*.scss": [
      "prettier --write"
    ]
  },
  "allowScripts": {
    "@parcel/watcher@2.5.6": true,
    "electron-winstaller@5.4.0": true,
    "esbuild@0.28.1": true,
    "lmdb@3.5.4": true,
    "msgpackr-extract@3.0.4": true,
    "sharp@0.32.6": true
  }
}